window.TOP = {}

import KV from './top/_kv.es6'

COMMON.kv = new KV()

